import React from 'react';

import { createComponent, Image } from 'console-kit';

const AuthImageLogo = createComponent({
  displayName: 'AuthImageLogo',
  render() {
    return <Image src={`${App.globalContext.assetURL}c/img/brand/zeta-grow-logo.svg?br=zeta`} />;
  },
});

export default AuthImageLogo;
